export enum Utbetald {
  JA = 'Ja',
  NEJ = 'Nej'
}
